<template>
    <div>
        <el-page-header @back="goBack" content="物品配置">
        </el-page-header>
        <el-card class="form-container" shadow="never">
            <el-button type="primary" @click="addPrize">添加物品</el-button>
        </el-card>
        <el-card class="form-container" shadow="never">
            <el-table
                    :data="packageList"
                    border
                    :fit="true">
                <el-table-column label="物品ID" prop="id"></el-table-column>
                <el-table-column label="物品名称" prop="prize.name"></el-table-column>
                <el-table-column label="图片素材">
                    <template slot-scope="scope" v-if="scope.row.prize.bigImage">
                        <img :src="VUE_APP_CDN_URL+scope.row.prize.bigImage" width="80px" height="80px" alt=""/>
                    </template>
                </el-table-column>
                <el-table-column label="排序(数值小靠前)" width="220px">
                    <template slot-scope="scope" >
                        <el-input-number :min="0" :max="100" style="width: 150px" type="text" v-model="scope.row.rank" @change="update(scope.row)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="次数限制" width="220px">
                    <template slot-scope="scope" >
                        <el-input-number :min="0" :max="9999" style="width: 150px" type="text" v-model="scope.row.offerLimit" @change="updateOfferLimit(scope.row)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="开关" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isUse"
                                   :active-value="true"
                                   :inactive-value="false"
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="update(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="父级节点" prop="pre"></el-table-column>
                <el-table-column label="下一节点" prop="next"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button :disabled="scope.row.isUse===false" plain type="primary" @click="configPiece(scope.row)">配置碎片</el-button>
                    <!-- 这里写死 只有type=4的才展示关系配置按钮 -->
                    <el-button :disabled="scope.row.type===4" plain type="primary" @click="configRelation(scope.row)">配置关系</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog title="添加物品" center :visible.sync="dialogVisible" @open="getData" width="400px">
            <h2 style="text-align: center;"> 活动名称:{{pageActivity.name}}</h2>
            <h1 style="text-align: center;">
                <el-select v-model="dailyActivityPrize.prizeIds" placeholder="请选择" multiple>
                    <el-option v-for="prize in Prizes"
                            :key="prize.id"
                            :label="prize.name"
                            :value="prize.id"></el-option>
                </el-select>
            </h1>
            <h1 style="text-align: center;">
                <el-button type="primary" @click="commit">提 交</el-button>
                <el-button type="info" @click="cutDialog">取 消</el-button>
            </h1>
        </el-dialog>
        <el-dialog title="修改关系" center :visible.sync="dialogVisibleRelation" @open="getRelationData" width="400px">
            <h2 style="text-align: center;"> 父级物品</h2>
            <h1 style="text-align: center;">
                <el-select v-model="dailyActivityPrize.pre" placeholder="请选择"  >
                    <el-option v-for="item in tempPrizes"
                            :key="item.id"
                            :label="item.id"
                            :value="item.id"></el-option>
                </el-select>
            </h1>
            <h2 style="text-align: center;"> 下一级物品</h2>
            <h1 style="text-align: center;">
                <el-select v-model="dailyActivityPrize.next" placeholder="请选择"  >
                    <el-option v-for="item in tempPrizes"
                            :key="item.id"
                            :label="item.id"
                            :value="item.id"></el-option>
                </el-select>
            </h1>
            <h1 style="text-align: center;">
                <el-button type="primary" @click="commitRelation">提 交</el-button>
                <el-button type="info" @click="cancelRelationDialog">取 消</el-button>
            </h1>
        </el-dialog>
    </div>
</template>

<script>
    import {
        allSelectData,
        addPrize,
        findPrizeByAid,
        updateRank,
        editRelation,
        updateOfferLimit
    } from "@/http/api";

    export default {
        inject: ['reload'],
        name: "AddPrize",
        data() {
            return {
                VUE_APP_CDN_URL: null,
                pageActivity: {},
                dialogVisible: false,
                dialogVisibleRelation:false,
                dailyActivityPrize: {
                    id: 0,
                    dailyActivityId: '',
                    dailyActivityPrizeRelId:null,
                    pre:null,
                    next: null,
                    offerLimit:null,
                    prizeIds: [],
                },
                Prizes: [],
                tempPrizes: [],
                packageList: [],
            }
        },
        methods: {
            goBack() {
                this.$router.push({name: 'ActivityConfig', params: {activeName: 'second'}})
            },
            getData() {
                allSelectData().then(resp => {
                    //包含 红包 和实物
                    this.Prizes = resp.data.info.prizes;
                });
            },
            getRelationData() { 
                 this.tempPrizes=this.packageList 
            },
            cutDialog() {
                this.dialogVisible = false;
            },
            cancelRelationDialog() {
                this.dialogVisibleRelation = false;
            },
            update(row){
                updateRank(row).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 1000
                        });
                    }
                });
            },
            updateOfferLimit(row){
                updateOfferLimit(row).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 1000
                        });
                    }
                });
            },
            addPrize() {
                this.dialogVisible = true;
                this.dailyActivityPrize.dailyActivityId = this.pageActivity.id;
            },
            commit() {
                if (this.dailyActivityPrize.prizeIds.length === 0) {
                    this.$message({
                        message: '请选择奖品',
                        type: 'error',
                        duration: 1000
                    });
                    return;
                }
                addPrize(this.dailyActivityPrize).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: '提交成功',
                            type: 'success',
                            duration: 1000
                        });
                        this.reload();
                    }
                });
            },
            configPiece(row) {
                this.$store.commit('config', row.prize.id);
                this.$router.push({path: '/configPiece'})
            },
            commitRelation() {
                 
                editRelation(this.dailyActivityPrize).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 1000
                        });
                        this.reload();
                    }
                });
            },
            configRelation(row) {
                this.dialogVisibleRelation = true;
                this.dailyActivityPrize.dailyActivityPrizeRelId = row.id;
            }
        },
        created() {
            //不在跳转参数中获取 从缓存中获取 避免刷新当前页面数据丢失
            this.pageActivity = this.$store.state.dailyActivity;
            findPrizeByAid(this.pageActivity.id).then(resp => {
                this.packageList = resp.data.info 
            /** 处理修改时，数字框null 展示为0的问题 */
            // console.log(this.packageList)
            //     for (var index in this.packageList) {
            //         console.log("item"+index )
            //     if (this.packageList[index].offerLimit === null) {
            //     this.packageList[index].offerLimit = undefined;
            //     }
            // }
            })
        },
        mounted() {
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>
